import { SpeakerWaveIcon } from "@heroicons/react/24/solid";
import useTextToSpeech from "./useTextToSpeech";

interface Props {
  message: string;
}

export function TTSButton({ message }: Props) {
  const tts = useTextToSpeech({ message, lang: "zh-TW" });

  return (
    <button
      onClick={() => {
        tts.start();
      }}
      className="rounded-sm border p-2 hover:bg-gray-200"
    >
      <SpeakerWaveIcon className="h-4 w-4" />
    </button>
  );
}
